module.exports = __webpack_public_path__ + "static/assets/158eba6dcb48bc43aba007ddf6320553.svg";